"use client";

import { Button } from "@/components/ui/button";
import { StepCard } from "./StepCard";
import type { StepStatus, AccountBalances } from "./types";

interface Step6Props {
  status: StepStatus;
  isConnected: boolean;
  activeAccountId: string;
  balances: AccountBalances;
  onWithdraw: () => void;
  onGoBack?: () => void;
}

export function Step6Withdraw({
  status,
  isConnected,
  activeAccountId,
  balances,
  onWithdraw,
  onGoBack,
}: Step6Props) {
  const isProcessing = status === "in-progress";
  const hasAqua = balances.lpAqua !== "0.00";
  const hasSoroswap = balances.lpSoroswap !== "0.00";
  const hasPositions = hasAqua || hasSoroswap;

  return (
    <StepCard
      stepNumber={6}
      title="Withdraw from LP"
      description="Redeem LP positions and get your tokens back"
      status={status}
      onGoBack={onGoBack}
      completedSummary={<span>LP positions redeemed — tokens returned to wallet</span>}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-2">
          <div className="bg-muted rounded-md p-3 text-center">
            <div className="text-xs text-muted-foreground mb-1">Aquarius LP</div>
            <div className="font-mono font-semibold text-sm text-cyan-400">
              {balances.lpAqua}
            </div>
            <div className="text-xs text-muted-foreground">shares</div>
          </div>
          <div className="bg-muted rounded-md p-3 text-center">
            <div className="text-xs text-muted-foreground mb-1">Soroswap LP</div>
            <div className="font-mono font-semibold text-sm text-purple-400">
              {balances.lpSoroswap}
            </div>
            <div className="text-xs text-muted-foreground">shares</div>
          </div>
        </div>

        <div className="text-xs text-muted-foreground bg-muted rounded-md p-3">
          Withdrawing burns your LP shares and returns USDC + XLM to your wallet.
          Each pool withdrawal is a separate transaction.
        </div>

        <Button
          onClick={onWithdraw}
          disabled={!activeAccountId || !isConnected || isProcessing || !hasPositions}
          variant="secondary"
          className="w-full"
        >
          {isProcessing
            ? "Withdrawing..."
            : hasPositions
              ? "Withdraw All LP Positions"
              : "No LP positions"}
        </Button>
      </div>
    </StepCard>
  );
}
